import {Axios} from "utils/Axios";
import {Constants} from "resources/constants";

export function login(email, password) {
    return Axios.post(`${Constants.baseUrl}/${Constants.authBase}/login`, {email, password})
}